import { useCurrentClientIfAvailable } from 'src/clients/context/CurrentClientProvider';
import { useAppContainerContext } from 'src/UI/app-container/AppContainerContext';
import { useSiesta } from 'src/UI/app-container/SiestaProvider';
import { useAppContainer } from 'src/UI/app-container/useAppContainer';

// Opens the Siesta panel in chat mode and sends a prewritten prompt — the
// recipe the suggested-action cards use, packaged for page-level CTAs.
// Family pages have no :clientId route param, so they pass the client the
// chat should run as (e.g. the family's main member) explicitly.
export function useAskSiesta() {
  const { clientId } = useCurrentClientIfAvailable();
  const { sendUserMessage, resetIfDisplaced } = useSiesta();
  const { setSiestaMode } = useAppContainer();
  const { setSidebarCollapsed } = useAppContainerContext();

  return async (prompt: string, asClientId?: string) => {
    const conversationId = resetIfDisplaced();
    setSidebarCollapsed(false);
    setSiestaMode('chat');
    await sendUserMessage(prompt, asClientId ?? clientId ?? null, conversationId);
  };
}
